import { TrainDependency } from '../../common/train';
import { DependencyTrains, TrainInfo } from './types';

export function getDependantByTripNumber(dependencyTrains: DependencyTrains, tripNumber: string) {
  let dependentTrain: TrainDependency;
  if (dependencyTrains?.dependentTrains) {
    dependentTrain = dependencyTrains.dependentTrains.find(dep => dep.trainNumber === tripNumber);
  }
  return dependentTrain;
}

export function isValidDependeeTrain(dependee: TrainDependency) {
  if (dependee.subDependencies?.compositions || dependee.subDependencies?.locs) {
    return dependee.location !== 'ILR' && dependee.location !== 'NOK';
  }
  return false;
}

export function getCompositionStringFromLegacyDependencies(dep: TrainDependency) {
  const parseArrayOrUndefined = (arr: string[]) => arr ? this.parseCompositionArray(arr) : undefined;
  const locs = parseArrayOrUndefined(dep.dependentLocs);
  const depCompositions = parseArrayOrUndefined(dep.dependent_compositions);
  return [locs, depCompositions].filter(val => !!val).join(' ');
}

export function parseCompositionArray(compositions: string[]): string {
  let val = '';
  if (!compositions) {
    return '';
  }
  for (const row of compositions) {
    if (row.includes('_')) {
      row.split('_').forEach(o => {
        val += o + ' ';
      });
    } else {
      val += row + ' ';
    }
  }
  return val.substring(0, val.length - 1);
}

export function getDeltaClass(delta: number, badge: boolean): string {
  if (delta != null) {
    if (delta <= 5) {
      return (badge ? 'badge' : 'text') + '-success';
    } else if (delta <= 15) {
      return (badge ? 'badge' : 'text') + '-warning';
    } else {
      return (badge ? 'badge' : 'text') + '-danger';
    }
  }
  return '';
}

export function getNodeTemplate(train: TrainInfo, classPostFix: string, dep: string, arr: string) {
  return `<div class="equipment-dependency-node${classPostFix}">
            <div style="display: flex; justify-content: space-between;">
              <span style="width: 2em;"></span>
              <span class="dep-time">${dep}: ${train.depTime} ${train.depTimeActual ? '<span><i class="fas fa-play"></i></span>' + train.depTimeActual : ''}</span>
              <span style="width: 2em;"></span>
            </div>
            <div class="content">
              <div class="train-title">
                <p>${train.title}</p>
              </div>
              <div class="composition">
                <p>${train.composition}</p>
              </div>
            </div>
            <div class="content" style="justify-content: space-between">
              <div style="width: 5em;">
                <span class="badge badge-pill badge-custom ${getDeltaClass(train.calculatedDelta, true)}"><span>${train.calculatedDelta != null ? train.calculatedDelta : ''}</span></span>
              </div>
              <span class="arr-time">${arr}: ${train.arrTime} ${train.arrTimeActual ? '<span><i class="fas fa-play"></i></span>' + train.arrTimeActual : ''}</span>
              <span style="width: 5em;"></span>
            </div>
          </div>`;
}

export function getStationTemplate(shortCode: string) {
  return `<div
            style="
              width: fit-content;
              padding-left: .5em;
              padding-right: .5em;
              margin-right: auto;
              margin-left: auto;
              border: 1px solid;
              border-radius: 15px"
          >
            ${shortCode}
          </div>`;
}
